import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Endpoints } from "../../../../helpers/Endpoints";
import { Globals } from "../../../../helpers/globals";
import { Base64EncodeStrings } from "../../../../helpers/utility";
import { authenticationService } from "../../../../services/authentication.service";

export default function CreatePaymentMethodModal(params: {
    modal: boolean;
    setModal: (value: boolean) => void;
    callback: () => void;
    setMessage: (value: string, isError: boolean) => void;
}): JSX.Element {
    const [accountName, setAccountName] = useState("");
    const portal = Globals.portalValue;
    const user = authenticationService.currentUserValue;
    const [path, setPath] = useState("");

    useEffect(() => {
        if (user) {
            setPath(
                Base64EncodeStrings([portal, user.username!, user.authToken!])
            );
        }
    }, [user]);

    return (
        <>
            <Modal show={params.modal} onHide={() => params.setModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create New Payment Account</Modal.Title>
                </Modal.Header>
                <form
                    method="post"
                    encType="application/x-www-form-urlencoded"
                    action={Endpoints.Tyler.PaymentExternalURL}
                >
                    <input
                        type="hidden"
                        name="RequestXML"
                        id="RequestXML"
                        value={
                            "<PaymentRequest><ClientKey>" +
                            Endpoints.Tyler.PaymentKey +
                            "</ClientKey><TransactionID>" +
                            Date.now() +
                            "</TransactionID><Amount>-1</Amount><GetToken>1</GetToken><RedirectURL>" +
                            Endpoints.Tyler.PaymentRedirect +
                            "/PaymentAccount/" +
                            path +
                            "?acctName=" +
                            accountName +
                            "</RedirectURL></PaymentRequest>"
                        }
                    ></input>
                    <Modal.Body>
                        <Form.Group controlId="newAccountName">
                            <Form.Label>Account Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Account Name"
                                name="AccountName"
                                value={accountName}
                                onChange={(e) => setAccountName(e.target.value)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => params.setModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Create
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}
